module.exports = "/static/assets/740d2ffdc270a38f10bee14e66cf2372.png";